
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class NodiGrid extends Serenity.EntityGrid<NodiRow, any> {
        protected getColumnsKey() { return NodiColumns.columnsKey; }
        protected getDialogType() { return NodiEditorDialog; }
        protected getIdProperty() { return NodiRow.idProperty; }
        protected getInsertPermission() { return NodiRow.insertPermission; }
        protected getLocalTextPrefix() { return NodiRow.localTextPrefix; }
        protected getService() { return NodiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            this.openDialogsAsPanel = true;
        }
    }
}